<script lang="ts">
	import { PrismicImage, PrismicRichText, SliceZone } from '@prismicio/svelte';
	import type { PageProps } from './$types';
	import { components } from '$lib/slices';
	import { page } from '$app/state';
	import { isFilled } from '@prismicio/client';
	import { inview } from 'svelte-inview';

	const { data }: PageProps = $props();
	const pageData = $derived(page.data.page);
</script>

<section
	class="page-header"
	class:image={isFilled.image(pageData.data.image)}
	use:inview
	oninview_enter={(event) => {
		const { node } = event.detail;
		node.classList.add('show');
	}}
>
	{#if isFilled.image(pageData.data.image)}
		<div class="page-header__image--container">
			<PrismicImage field={pageData.data.image} class="page-header__image" loading="lazy" />
		</div>
	{/if}

	<div class="page-header__content">
		<div class="container h-100">
			<div class="row h-100 justify-content-center">
				<div class="col-12 col-lg-8 col-hd-6">
					{#if isFilled.richText(pageData.data.title)}
						<div class="page-header__content--title">
							<PrismicRichText field={pageData.data.title} />
						</div>
					{/if}

					{#if isFilled.richText(pageData.data.description)}
						<div class="page-header__content--description">
							<PrismicRichText field={pageData.data.description} />
						</div>
					{/if}
				</div>
			</div>
		</div>
	</div>
</section>

<SliceZone slices={data.page.data.slices} {components} />
